import { render } from "./SubPanelConfigContent.vue?vue&type=template&id=26e37714&scoped=true"
import script from "./SubPanelConfigContent.vue?vue&type=script&lang=ts"
export * from "./SubPanelConfigContent.vue?vue&type=script&lang=ts"

import "./SubPanelConfigContent.vue?vue&type=style&index=0&id=26e37714&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-26e37714"

export default script